
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.938 3.094c1 0 2.218-.313 3.656-1 .312-.125.625-.125.937.062.313.188.469.469.469.844v7.594a.906.906 0 01-.438.812c-1.25.875-2.5 1.281-3.812 1.281-.5 0-1.031-.062-1.563-.187a8.33 8.33 0 01-1.343-.406c-.5-.156-.875-.281-1.125-.344-.438-.094-.813-.156-1.157-.156-1.312 0-2.5.25-3.562.719v2.937a.754.754 0 01-.219.531.732.732 0 01-.531.219h-.5c-.219 0-.406-.063-.531-.219C1.062 15.656 1 15.47 1 15.25V3.187a1.543 1.543 0 01-.563-.624A1.73 1.73 0 01.25 1.75c0-.5.156-.906.531-1.25.344-.344.781-.5 1.281-.5.438.031.844.188 1.157.5.312.313.5.688.531 1.125 0 .281-.031.531-.125.75A6.086 6.086 0 015.75 2c.5 0 1 .063 1.563.188.312.093.75.218 1.343.406.5.187.875.281 1.125.344a3.81 3.81 0 001.156.156z","fill":"#fff"}})])
          )
        }
      }
    